import { t } from '@lingui/core/macro';
import { Select } from 'shared/domains/forms';
import { supportedMarkets, globalMarket } from 'shared/domains/markets/config';
export function MarketField() {
    const label = t({
        message: 'Main market',
        comment: 'signup market select label',
    });
    const placeholder = t({
        message: 'Select market',
        comment: 'signup market select placeholder',
    });
    const allMarketsWithGlobal = [...supportedMarkets, globalMarket];
    return (<Select.Root label={label} name="marketCode" placeholder={placeholder}>
      {allMarketsWithGlobal.map((market) => (<Select.Option key={market.id} value={market.code}>
          {market.getName()}
        </Select.Option>))}
    </Select.Root>);
}
